import { render } from "./Sleep.vue?vue&type=template&id=b0daab68&scoped=true"
import script from "./Sleep.vue?vue&type=script&lang=js"
export * from "./Sleep.vue?vue&type=script&lang=js"

import "./Sleep.vue?vue&type=style&index=0&id=b0daab68&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0daab68"]])

export default __exports__